import React from 'react';
import { Typography } from '@mui/material';
import { CHAR_LIMIT } from './constants';

const CharCount = ({ value, limit = CHAR_LIMIT }) => (
  <Typography variant='caption' color='text.secondary' sx={{ display: 'block', textAlign: 'right', mt: 0.5 }}>
    {(value || '').length}/{limit}
  </Typography>
);

export default CharCount;
